"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.ContentType = exports.StoreOrderDtoPaymentIntervalEnum = exports.FrameworkDtoStorageTypeEnum = exports.PasswordEmailDtoUserTypeEnum = exports.LoginDtoUserTypeEnum = exports.IntersectionIntersectionAuthClientDtoAuthAdminDtoAuthVendorDtoRoleEnum = exports.LanguageDirection = exports.UserRole = exports.AuthType = exports.UserType = exports.AdminPermissions = exports.NotificationType = exports.ProductType = exports.PaymentInterval = exports.Category = exports.RequiredField = exports.FrameworkPlatform = exports.StorageType = exports.FileType = exports.PaymentStatus = exports.PaymentProviderCode = exports.FrameworkCode = exports.CredentialType = exports.AccessTokenType = exports.AccessTokenPermission = exports.ModificationCode = exports.Resource = exports.AdminRole = exports.VendorStatus = exports.PaymentIntervalTitle = exports.DealStatus = exports.DealStep = exports.StatisticGroupType = exports.TrustedSourceType = exports.FeatureCode = exports.TermsTypeEnum = exports.TermsStatusEnum = exports.PageType = exports.TechStack = exports.ToolType = exports.GenaiRequestStatus = exports.FeatureLimitCode = void 0;
var FeatureLimitCode;
(function (FeatureLimitCode) {
    FeatureLimitCode["Languages"] = "languages";
    FeatureLimitCode["ImageExtensions"] = "image_extensions";
})(FeatureLimitCode || (exports.FeatureLimitCode = FeatureLimitCode = {}));
var GenaiRequestStatus;
(function (GenaiRequestStatus) {
    GenaiRequestStatus["New"] = "new";
    GenaiRequestStatus["Pending"] = "pending";
    GenaiRequestStatus["Completed"] = "completed";
    GenaiRequestStatus["Failed"] = "failed";
})(GenaiRequestStatus || (exports.GenaiRequestStatus = GenaiRequestStatus = {}));
var ToolType;
(function (ToolType) {
    ToolType["A11YSg"] = "a11y_sg";
    ToolType["A11YScanner"] = "a11y_scanner";
})(ToolType || (exports.ToolType = ToolType = {}));
var TechStack;
(function (TechStack) {
    TechStack["Android"] = "android";
    TechStack["Ios"] = "ios";
    TechStack["ReactNative"] = "react_native";
    TechStack["Flutter"] = "flutter";
    TechStack["React"] = "react";
    TechStack["Angular"] = "angular";
    TechStack["Vue"] = "vue";
    TechStack["Wordpress"] = "wordpress";
    TechStack["Shopify"] = "shopify";
    TechStack["Magento"] = "magento";
    TechStack["Umbraco"] = "umbraco";
    TechStack["Other"] = "other";
})(TechStack || (exports.TechStack = TechStack = {}));
var PageType;
(function (PageType) {
    PageType["PAGE"] = "PAGE";
    PageType["FILE"] = "FILE";
})(PageType || (exports.PageType = PageType = {}));
var TermsStatusEnum;
(function (TermsStatusEnum) {
    TermsStatusEnum["DRAFT"] = "DRAFT";
    TermsStatusEnum["ACTIVE"] = "ACTIVE";
    TermsStatusEnum["DELETED"] = "DELETED";
})(TermsStatusEnum || (exports.TermsStatusEnum = TermsStatusEnum = {}));
var TermsTypeEnum;
(function (TermsTypeEnum) {
    TermsTypeEnum["ACCESSIBILITY_STATEMENT"] = "ACCESSIBILITY_STATEMENT";
    TermsTypeEnum["PRIVACY_POLICY"] = "PRIVACY_POLICY";
    TermsTypeEnum["TERMS_AND_CONDITIONS"] = "TERMS_AND_CONDITIONS";
    TermsTypeEnum["EULA"] = "EULA";
})(TermsTypeEnum || (exports.TermsTypeEnum = TermsTypeEnum = {}));
var FeatureCode;
(function (FeatureCode) {
    FeatureCode["AiImageDescriptionGeneration"] = "ai-image-description-generation";
})(FeatureCode || (exports.FeatureCode = FeatureCode = {}));
var TrustedSourceType;
(function (TrustedSourceType) {
    TrustedSourceType["DOMAIN"] = "DOMAIN";
    TrustedSourceType["IP_ADDRESS"] = "IP_ADDRESS";
    TrustedSourceType["EMAIL"] = "EMAIL";
})(TrustedSourceType || (exports.TrustedSourceType = TrustedSourceType = {}));
var StatisticGroupType;
(function (StatisticGroupType) {
    StatisticGroupType["DAY"] = "DAY";
    StatisticGroupType["HOUR"] = "HOUR";
})(StatisticGroupType || (exports.StatisticGroupType = StatisticGroupType = {}));
var DealStep;
(function (DealStep) {
    DealStep["PRODUCT"] = "PRODUCT";
    DealStep["CLIENT"] = "CLIENT";
    DealStep["PAYMENT"] = "PAYMENT";
})(DealStep || (exports.DealStep = DealStep = {}));
var DealStatus;
(function (DealStatus) {
    DealStatus["DRAFT"] = "DRAFT";
    DealStatus["ACTIVE"] = "ACTIVE";
})(DealStatus || (exports.DealStatus = DealStatus = {}));
var PaymentIntervalTitle;
(function (PaymentIntervalTitle) {
    PaymentIntervalTitle["Onetime"] = "Onetime";
    PaymentIntervalTitle["Monthly"] = "Monthly";
    PaymentIntervalTitle["Anually"] = "Anually";
    PaymentIntervalTitle["Value2Years"] = "2 Years";
})(PaymentIntervalTitle || (exports.PaymentIntervalTitle = PaymentIntervalTitle = {}));
var VendorStatus;
(function (VendorStatus) {
    VendorStatus["ACTIVE"] = "ACTIVE";
    VendorStatus["NEW"] = "NEW";
    VendorStatus["DELETED"] = "DELETED";
})(VendorStatus || (exports.VendorStatus = VendorStatus = {}));
var AdminRole;
(function (AdminRole) {
    AdminRole["Admin"] = "admin";
    AdminRole["Legal"] = "legal";
    AdminRole["Sales"] = "sales";
    AdminRole["BizDev"] = "biz_dev";
    AdminRole["RD"] = "r_d";
    AdminRole["CustomerSuccess"] = "customer_success";
    AdminRole["Bdr"] = "bdr";
})(AdminRole || (exports.AdminRole = AdminRole = {}));
var Resource;
(function (Resource) {
    Resource["BLOG"] = "BLOG";
    Resource["ENTERPRISE_LANDING_PAGE"] = "ENTERPRISE_LANDING_PAGE";
    Resource["HOME_LANDING_PAGE"] = "HOME_LANDING_PAGE";
    Resource["EAA_LANDING_PAGE"] = "EAA_LANDING_PAGE";
    Resource["PRICING_BLOCK"] = "PRICING_BLOCK";
    Resource["WHITEPAPERS"] = "WHITEPAPERS";
    Resource["ALTERNATIVES"] = "ALTERNATIVES";
    Resource["ACCESSIBILITY_CHECKER"] = "ACCESSIBILITY_CHECKER";
    Resource["UNKNOWN"] = "UNKNOWN";
})(Resource || (exports.Resource = Resource = {}));
var ModificationCode;
(function (ModificationCode) {
    ModificationCode["FRAMEWORKS"] = "FRAMEWORKS";
    ModificationCode["USERS"] = "USERS";
    ModificationCode["DOMAINS"] = "DOMAINS";
    ModificationCode["TRAININGANDAUDITING20H"] = "TRAINING_AND_AUDITING_20H";
    ModificationCode["ACCESSIBILITY_COMPONENTS"] = "ACCESSIBILITY_COMPONENTS";
    ModificationCode["ADDITIONAL_AUDITING_SERVICE"] = "ADDITIONAL_AUDITING_SERVICE";
    ModificationCode["PAYMENT_INTERVAL"] = "PAYMENT_INTERVAL";
})(ModificationCode || (exports.ModificationCode = ModificationCode = {}));
var AccessTokenPermission;
(function (AccessTokenPermission) {
    AccessTokenPermission["READ"] = "READ";
    AccessTokenPermission["WRITE"] = "WRITE";
})(AccessTokenPermission || (exports.AccessTokenPermission = AccessTokenPermission = {}));
var AccessTokenType;
(function (AccessTokenType) {
    AccessTokenType["RUNTIME"] = "RUNTIME";
    AccessTokenType["INSTALLATION"] = "INSTALLATION";
})(AccessTokenType || (exports.AccessTokenType = AccessTokenType = {}));
var CredentialType;
(function (CredentialType) {
    CredentialType["BASIC"] = "BASIC";
    CredentialType["TOKEN"] = "TOKEN";
})(CredentialType || (exports.CredentialType = CredentialType = {}));
var FrameworkCode;
(function (FrameworkCode) {
    FrameworkCode["REACT"] = "REACT";
    FrameworkCode["VUEJS"] = "VUEJS";
    FrameworkCode["ANGULAR"] = "ANGULAR";
    FrameworkCode["JAVASCRIPT"] = "JAVASCRIPT";
    FrameworkCode["ANDROID_XML_SDK"] = "ANDROID_XML_SDK";
    FrameworkCode["IOS_SDK"] = "IOS_SDK";
    FrameworkCode["REACT_NATIVE_SDK"] = "REACT_NATIVE_SDK";
    FrameworkCode["FLUTTER_SDK"] = "FLUTTER_SDK";
})(FrameworkCode || (exports.FrameworkCode = FrameworkCode = {}));
var PaymentProviderCode;
(function (PaymentProviderCode) {
    PaymentProviderCode["STRIPE"] = "STRIPE";
})(PaymentProviderCode || (exports.PaymentProviderCode = PaymentProviderCode = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["DRAFT"] = "DRAFT";
    PaymentStatus["PROCEEDED"] = "PROCEEDED";
    PaymentStatus["IN_PROGRESS"] = "IN_PROGRESS";
    PaymentStatus["CANCELED"] = "CANCELED";
    PaymentStatus["FAILED"] = "FAILED";
    PaymentStatus["REFUNDED"] = "REFUNDED";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
var FileType;
(function (FileType) {
    FileType["CSS"] = "CSS";
    FileType["JS"] = "JS";
})(FileType || (exports.FileType = FileType = {}));
var StorageType;
(function (StorageType) {
    StorageType["VERDACCIO"] = "VERDACCIO";
    StorageType["CLOUDSMITH"] = "CLOUDSMITH";
    StorageType["AWSS3"] = "AWS_S3";
    StorageType["GITHUB"] = "GITHUB";
})(StorageType || (exports.StorageType = StorageType = {}));
var FrameworkPlatform;
(function (FrameworkPlatform) {
    FrameworkPlatform["WEB"] = "WEB";
    FrameworkPlatform["MOBILE"] = "MOBILE";
})(FrameworkPlatform || (exports.FrameworkPlatform = FrameworkPlatform = {}));
var RequiredField;
(function (RequiredField) {
    RequiredField["Domain"] = "domain";
    RequiredField["AppId"] = "appId";
    RequiredField["BundleId"] = "bundleId";
})(RequiredField || (exports.RequiredField = RequiredField = {}));
var Category;
(function (Category) {
    Category["MAIN"] = "MAIN";
    Category["EXTRA"] = "EXTRA";
})(Category || (exports.Category = Category = {}));
var PaymentInterval;
(function (PaymentInterval) {
    PaymentInterval["ONETIME"] = "ONETIME";
    PaymentInterval["MONTH"] = "MONTH";
    PaymentInterval["YEAR"] = "YEAR";
    PaymentInterval["TWO_YEARS"] = "TWO_YEARS";
})(PaymentInterval || (exports.PaymentInterval = PaymentInterval = {}));
var ProductType;
(function (ProductType) {
    ProductType["FREE"] = "FREE";
    ProductType["MAIN"] = "MAIN";
    ProductType["CUSTOM"] = "CUSTOM";
    ProductType["DEAL"] = "DEAL";
})(ProductType || (exports.ProductType = ProductType = {}));
var NotificationType;
(function (NotificationType) {
    NotificationType["EMAIL"] = "EMAIL";
    NotificationType["SMS"] = "SMS";
    NotificationType["SLACK"] = "SLACK";
})(NotificationType || (exports.NotificationType = NotificationType = {}));
var AdminPermissions;
(function (AdminPermissions) {
    AdminPermissions["ReadAdmin"] = "read_admin";
    AdminPermissions["ExportAdmin"] = "export_admin";
    AdminPermissions["CreateAdmin"] = "create_admin";
    AdminPermissions["UpdateAdmin"] = "update_admin";
    AdminPermissions["DeleteAdmin"] = "delete_admin";
    AdminPermissions["ManageAdmins"] = "manage_admins";
    AdminPermissions["ReadAdminRole"] = "read_admin-role";
    AdminPermissions["UpdateAdminRole"] = "update_admin-role";
    AdminPermissions["ManageAdminRoles"] = "manage_admin-roles";
    AdminPermissions["ReadVendor"] = "read_vendor";
    AdminPermissions["ExportVendor"] = "export_vendor";
    AdminPermissions["CreateVendor"] = "create_vendor";
    AdminPermissions["UpdateVendor"] = "update_vendor";
    AdminPermissions["DeleteVendor"] = "delete_vendor";
    AdminPermissions["ManageVendors"] = "manage_vendors";
    AdminPermissions["ReadTrustedSource"] = "read_trusted-source";
    AdminPermissions["ExportTrustedSource"] = "export_trusted-source";
    AdminPermissions["CreateTrustedSource"] = "create_trusted-source";
    AdminPermissions["UpdateTrustedSource"] = "update_trusted-source";
    AdminPermissions["DeleteTrustedSource"] = "delete_trusted-source";
    AdminPermissions["ManageTrustedSources"] = "manage_trusted-sources";
    AdminPermissions["ReadTerms"] = "read_terms";
    AdminPermissions["CreateTerms"] = "create_terms";
    AdminPermissions["UpdateTerms"] = "update_terms";
    AdminPermissions["DeleteTerms"] = "delete_terms";
    AdminPermissions["ManageTerms"] = "manage_terms";
    AdminPermissions["ReadProjectAccessToken"] = "read_project-access-token";
    AdminPermissions["CreateProjectAccessToken"] = "create_project-access-token";
    AdminPermissions["UpdateProjectAccessToken"] = "update_project-access-token";
    AdminPermissions["DeleteProjectAccessToken"] = "delete_project-access-token";
    AdminPermissions["ManageProjectAccessTokens"] = "manage_project-access-tokens";
    AdminPermissions["ReadFramework"] = "read_framework";
    AdminPermissions["CreateFramework"] = "create_framework";
    AdminPermissions["UpdateFramework"] = "update_framework";
    AdminPermissions["DeleteFramework"] = "delete_framework";
    AdminPermissions["ManageFrameworks"] = "manage_frameworks";
    AdminPermissions["ReadTranslation"] = "read_translation";
    AdminPermissions["CreateTranslation"] = "create_translation";
    AdminPermissions["UpdateTranslation"] = "update_translation";
    AdminPermissions["DeleteTranslation"] = "delete_translation";
    AdminPermissions["ManageTranslations"] = "manage_translations";
    AdminPermissions["ReadLanguage"] = "read_language";
    AdminPermissions["CreateLanguage"] = "create_language";
    AdminPermissions["UpdateLanguage"] = "update_language";
    AdminPermissions["DeleteLanguage"] = "delete_language";
    AdminPermissions["ManageLanguages"] = "manage_languages";
    AdminPermissions["ReadEnterprise"] = "read_enterprise";
    AdminPermissions["CreateEnterprise"] = "create_enterprise";
    AdminPermissions["UpdateEnterprise"] = "update_enterprise";
    AdminPermissions["DeleteEnterprise"] = "delete_enterprise";
    AdminPermissions["ManageEnterprises"] = "manage_enterprises";
    AdminPermissions["ManageAll"] = "manage_all";
    AdminPermissions["ReadLead"] = "read_lead";
    AdminPermissions["ExportLead"] = "export_lead";
    AdminPermissions["CreateLead"] = "create_lead";
    AdminPermissions["UpdateLead"] = "update_lead";
    AdminPermissions["DeleteLead"] = "delete_lead";
    AdminPermissions["ManageLeads"] = "manage_leads";
    AdminPermissions["ReadPackageVersion"] = "read_package-version";
    AdminPermissions["ManagePackageVersions"] = "manage_package-versions";
    AdminPermissions["ReadFreeToolUsageHistory"] = "read_free-tool-usage-history";
    AdminPermissions["ManageFreeToolUsageHistory"] = "manage_free-tool-usage-history";
    AdminPermissions["FreeToolA11YScanner"] = "free-tool-a11y-scanner";
})(AdminPermissions || (exports.AdminPermissions = AdminPermissions = {}));
var UserType;
(function (UserType) {
    UserType["CLIENT"] = "CLIENT";
    UserType["ADMIN"] = "ADMIN";
    UserType["VENDOR"] = "VENDOR";
})(UserType || (exports.UserType = UserType = {}));
var AuthType;
(function (AuthType) {
    AuthType["GOOGLE"] = "GOOGLE";
    AuthType["GITHUB"] = "GITHUB";
    AuthType["BITBUCKET"] = "BITBUCKET";
    AuthType["MICROSOFT"] = "MICROSOFT";
    AuthType["LINKEDIN"] = "LINKEDIN";
    AuthType["QA"] = "QA";
})(AuthType || (exports.AuthType = AuthType = {}));
var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["USER"] = "USER";
    UserRole["ENTERPRISE"] = "ENTERPRISE";
})(UserRole || (exports.UserRole = UserRole = {}));
var LanguageDirection;
(function (LanguageDirection) {
    LanguageDirection["Ltr"] = "ltr";
    LanguageDirection["Rtl"] = "rtl";
})(LanguageDirection || (exports.LanguageDirection = LanguageDirection = {}));
var IntersectionIntersectionAuthClientDtoAuthAdminDtoAuthVendorDtoRoleEnum;
(function (IntersectionIntersectionAuthClientDtoAuthAdminDtoAuthVendorDtoRoleEnum) {
    IntersectionIntersectionAuthClientDtoAuthAdminDtoAuthVendorDtoRoleEnum["Admin"] = "admin";
    IntersectionIntersectionAuthClientDtoAuthAdminDtoAuthVendorDtoRoleEnum["Legal"] = "legal";
    IntersectionIntersectionAuthClientDtoAuthAdminDtoAuthVendorDtoRoleEnum["Sales"] = "sales";
    IntersectionIntersectionAuthClientDtoAuthAdminDtoAuthVendorDtoRoleEnum["BizDev"] = "biz_dev";
    IntersectionIntersectionAuthClientDtoAuthAdminDtoAuthVendorDtoRoleEnum["RD"] = "r_d";
    IntersectionIntersectionAuthClientDtoAuthAdminDtoAuthVendorDtoRoleEnum["CustomerSuccess"] = "customer_success";
    IntersectionIntersectionAuthClientDtoAuthAdminDtoAuthVendorDtoRoleEnum["Bdr"] = "bdr";
})(IntersectionIntersectionAuthClientDtoAuthAdminDtoAuthVendorDtoRoleEnum || (exports.IntersectionIntersectionAuthClientDtoAuthAdminDtoAuthVendorDtoRoleEnum = IntersectionIntersectionAuthClientDtoAuthAdminDtoAuthVendorDtoRoleEnum = {}));
var LoginDtoUserTypeEnum;
(function (LoginDtoUserTypeEnum) {
    LoginDtoUserTypeEnum["ADMIN"] = "ADMIN";
    LoginDtoUserTypeEnum["VENDOR"] = "VENDOR";
})(LoginDtoUserTypeEnum || (exports.LoginDtoUserTypeEnum = LoginDtoUserTypeEnum = {}));
var PasswordEmailDtoUserTypeEnum;
(function (PasswordEmailDtoUserTypeEnum) {
    PasswordEmailDtoUserTypeEnum["ADMIN"] = "ADMIN";
    PasswordEmailDtoUserTypeEnum["VENDOR"] = "VENDOR";
})(PasswordEmailDtoUserTypeEnum || (exports.PasswordEmailDtoUserTypeEnum = PasswordEmailDtoUserTypeEnum = {}));
var FrameworkDtoStorageTypeEnum;
(function (FrameworkDtoStorageTypeEnum) {
    FrameworkDtoStorageTypeEnum["VERDACCIO"] = "VERDACCIO";
    FrameworkDtoStorageTypeEnum["CLOUDSMITH"] = "CLOUDSMITH";
    FrameworkDtoStorageTypeEnum["AWSS3"] = "AWS_S3";
    FrameworkDtoStorageTypeEnum["GITHUB"] = "GITHUB";
})(FrameworkDtoStorageTypeEnum || (exports.FrameworkDtoStorageTypeEnum = FrameworkDtoStorageTypeEnum = {}));
var StoreOrderDtoPaymentIntervalEnum;
(function (StoreOrderDtoPaymentIntervalEnum) {
    StoreOrderDtoPaymentIntervalEnum["MONTH"] = "MONTH";
    StoreOrderDtoPaymentIntervalEnum["YEAR"] = "YEAR";
})(StoreOrderDtoPaymentIntervalEnum || (exports.StoreOrderDtoPaymentIntervalEnum = StoreOrderDtoPaymentIntervalEnum = {}));
const axios_1 = require("axios");
var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (exports.ContentType = ContentType = {}));
class HttpClient {
    instance;
    securityData = null;
    securityWorker;
    secure;
    format;
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.instance = axios_1.default.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || "http://localhost:3001",
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method &&
                    this.instance.defaults.headers[method.toLowerCase()]) ||
                    {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        if (input instanceof FormData) {
            return input;
        }
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
    request = async ({ secure, path, type, query, format, body, ...params }) => {
        const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
            this.securityWorker &&
            (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = format || this.format || undefined;
        if (type === ContentType.FormData &&
            body &&
            body !== null &&
            typeof body === "object") {
            body = this.createFormData(body);
        }
        if (type === ContentType.Text &&
            body &&
            body !== null &&
            typeof body !== "string") {
            body = JSON.stringify(body);
        }
        return this.instance
            .request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type ? { "Content-Type": type } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
        })
            .then((response) => response.data);
    };
}
exports.HttpClient = HttpClient;
class Api extends HttpClient {
    api = {
        translationPublicControllerGetAllV1: (params = {}) => this.request({
            path: `/api/v1/translations/all`,
            method: "GET",
            ...params,
        }),
        translationPublicControllerGetLanguagesV1: (params = {}) => this.request({
            path: `/api/v1/translations/languages`,
            method: "GET",
            format: "json",
            ...params,
        }),
        translationAdminControllerIndexV1: (query, params = {}) => this.request({
            path: `/api/v1/translations`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        translationAdminControllerStoreV1: (data, params = {}) => this.request({
            path: `/api/v1/translations`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        translationAdminControllerShowV1: (id, params = {}) => this.request({
            path: `/api/v1/translations/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        translationAdminControllerUpdateV1: (id, data, params = {}) => this.request({
            path: `/api/v1/translations/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        translationAdminControllerDeleteV1: (id, params = {}) => this.request({
            path: `/api/v1/translations/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        translationAdminControllerSyncTranslationsV1: (language, data, params = {}) => this.request({
            path: `/api/v1/translations/${language}/sync`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        translationAdminControllerRefreshV1: (params = {}) => this.request({
            path: `/api/v1/translations/refresh`,
            method: "POST",
            secure: true,
            ...params,
        }),
        languageAdminControllerIndexV1: (query, params = {}) => this.request({
            path: `/api/v1/languages`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        languageAdminControllerStoreV1: (data, params = {}) => this.request({
            path: `/api/v1/languages`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        languageAdminControllerShowV1: (id, params = {}) => this.request({
            path: `/api/v1/languages/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        languageAdminControllerUpdateV1: (id, data, params = {}) => this.request({
            path: `/api/v1/languages/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        languageAdminControllerDeleteV1: (id, params = {}) => this.request({
            path: `/api/v1/languages/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        googleControllerCallbackV1: (params = {}) => this.request({
            path: `/api/v1/sso/google/callback`,
            method: "GET",
            format: "json",
            ...params,
        }),
        githubControllerCallbackV1: (params = {}) => this.request({
            path: `/api/v1/sso/github/callback`,
            method: "GET",
            format: "json",
            ...params,
        }),
        bitbucketControllerCallbackV1: (params = {}) => this.request({
            path: `/api/v1/sso/bitbucket/callback`,
            method: "GET",
            format: "json",
            ...params,
        }),
        linkedinControllerCallbackV1: (params = {}) => this.request({
            path: `/api/v1/sso/linkedin/callback`,
            method: "GET",
            format: "json",
            ...params,
        }),
        microsoftControllerCallbackV1: (params = {}) => this.request({
            path: `/api/v1/sso/microsoft/callback`,
            method: "GET",
            format: "json",
            ...params,
        }),
        authControllerUserV1: (params = {}) => this.request({
            path: `/api/v1/auth/user`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        authControllerMeV1: (params = {}) => this.request({
            path: `/api/v1/auth/me`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        ssoControllerRedirectV1: (service, params = {}) => this.request({
            path: `/api/v1/sso/${service}`,
            method: "GET",
            ...params,
        }),
        loginControllerLoginV1: (data, params = {}) => this.request({
            path: `/api/v1/auth/login`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        passwordControllerSendResetEmailV1: (data, params = {}) => this.request({
            path: `/api/v1/passwords/send-reset-email`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            ...params,
        }),
        passwordControllerPasswordResetV1: (data, params = {}) => this.request({
            path: `/api/v1/passwords/reset`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            ...params,
        }),
        twoFaControllerIndexV1: (params = {}) => this.request({
            path: `/api/v1/2fa-verification`,
            method: "GET",
            secure: true,
            ...params,
        }),
        twoFaControllerSendV1: (data, params = {}) => this.request({
            path: `/api/v1/2fa-verification/send`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        twoFaControllerValidateV1: (data, params = {}) => this.request({
            path: `/api/v1/2fa-verification/verify`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        authRefreshControllerRefreshV1: (data, params = {}) => this.request({
            path: `/api/v1/auth/refresh`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        qaControllerCallbackV1: (data, params = {}) => this.request({
            path: `/api/v1/sso/qa/callback`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        productControllerGetProductsV1: (params = {}) => this.request({
            path: `/api/v1/products`,
            method: "GET",
            format: "json",
            ...params,
        }),
        productControllerGetProductV1: (id, params = {}) => this.request({
            path: `/api/v1/products/${id}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        modificationControllerIndexV1: (params = {}) => this.request({
            path: `/api/v1/modifications`,
            method: "GET",
            format: "json",
            ...params,
        }),
        frameworkControllerIndexV1: (query, params = {}) => this.request({
            path: `/api/v1/frameworks`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        frameworkControllerFindByIdV1: (id, params = {}) => this.request({
            path: `/api/v1/frameworks/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        frameworkControllerUpdateV1: (id, data, params = {}) => this.request({
            path: `/api/v1/frameworks/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        orderControllerStoreOrderV1: (data, params = {}) => this.request({
            path: `/api/v1/orders`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        orderUpgradeControllerUpgradeV1: (data, params = {}) => this.request({
            path: `/api/v1/orders/upgrade`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        orderHistoryControllerIndexV1: (params = {}) => this.request({
            path: `/api/v1/orders/history`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        receiptControllerDownloadV1: (id, params = {}) => this.request({
            path: `/api/v1/orders/${id}/receipts/download`,
            method: "GET",
            secure: true,
            ...params,
        }),
        orderPaymentControllerSessionV1: (id, params = {}) => this.request({
            path: `/api/v1/orders/${id}/payments/sessions`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
        paymentMethodControllerIndexV1: (params = {}) => this.request({
            path: `/api/v1/payments/methods`,
            method: "GET",
            secure: true,
            ...params,
        }),
        paymentMethodControllerStoreV1: (params = {}) => this.request({
            path: `/api/v1/payments/methods`,
            method: "POST",
            secure: true,
            ...params,
        }),
        stripeControllerWebhooksV1: (params = {}) => this.request({
            path: `/api/v1/payments/stripe/webhooks`,
            method: "POST",
            ...params,
        }),
        couponControllerGetDiscountV1: (productId, code, params = {}) => this.request({
            path: `/api/v1/products/${productId}/coupons/${code}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        projectControllerIndexV1: (params = {}) => this.request({
            path: `/api/v1/projects`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        projectControllerStoreV1: (data, params = {}) => this.request({
            path: `/api/v1/projects`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        projectControllerShowV1: (id, params = {}) => this.request({
            path: `/api/v1/projects/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        permissionControllerValidateV1: (data, params = {}) => this.request({
            path: `/api/v1/projects/permissions/validate`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        permissionControllerRuntimeV1: (params = {}) => this.request({
            path: `/api/v1/projects/permissions/runtime`,
            method: "GET",
            format: "json",
            ...params,
        }),
        projectDocsControllerGetDocsV1: (id, params = {}) => this.request({
            path: `/api/v1/projects/${id}/docs`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        projectConfigControllerGetDocsV1: (id, params = {}) => this.request({
            path: `/api/v1/projects/${id}/config`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        projectFrameworksControllerGetFrameworksV1: (params = {}) => this.request({
            path: `/api/v1/projects/frameworks`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        freemiumControllerStoreV1: (data, params = {}) => this.request({
            path: `/api/v1/freemium`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        activeSubscriptionControllerCompanyActiveSubscriptionV1: (params = {}) => this.request({
            path: `/api/v1/subscriptions/active`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        activeSubscriptionControllerUpdateV1: (data, params = {}) => this.request({
            path: `/api/v1/subscriptions/active`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        subscriptionPaymentControllerRepeatV1: (id, params = {}) => this.request({
            path: `/api/v1/subscriptions/${id}/payments/repeat`,
            method: "POST",
            secure: true,
            ...params,
        }),
        subscriptionQaControllerUpdateV1: (id, data, params = {}) => this.request({
            path: `/api/v1/subscriptions/${id}`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            ...params,
        }),
        settingControllerActiveProductsV1: (params = {}) => this.request({
            path: `/api/v1/settings`,
            method: "GET",
            format: "json",
            ...params,
        }),
        contactUsControllerStoreV1: (data, params = {}) => this.request({
            path: `/api/v1/support/contact-us`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            ...params,
        }),
        healthControllerIndex: (params = {}) => this.request({
            path: `/api/health`,
            method: "GET",
            ...params,
        }),
        adminControllerGetAdminsV1: (query, params = {}) => this.request({
            path: `/api/v1/admins`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        adminControllerStoreAdminV1: (data, params = {}) => this.request({
            path: `/api/v1/admins`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        adminControllerExportAdminsV1: (query, params = {}) => this.request({
            path: `/api/v1/admins/export`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
        adminControllerGetAdminV1: (id, params = {}) => this.request({
            path: `/api/v1/admins/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        adminControllerUpdateAdminV1: (id, data, params = {}) => this.request({
            path: `/api/v1/admins/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        adminControllerDeleteAdminV1: (id, params = {}) => this.request({
            path: `/api/v1/admins/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        adminQaControllerHardDeleteV1: (email, params = {}) => this.request({
            path: `/api/v1/admins/emails/${email}`,
            method: "DELETE",
            ...params,
        }),
        adminRoleControllerGetAdminsV1: (params = {}) => this.request({
            path: `/api/v1/admins/roles`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        vendorControllerGetVendorsV1: (query, params = {}) => this.request({
            path: `/api/v1/vendors`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        vendorControllerStoreVendorV1: (data, params = {}) => this.request({
            path: `/api/v1/vendors`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        vendorControllerExportVendorsV1: (query, params = {}) => this.request({
            path: `/api/v1/vendors/export`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
        vendorControllerResendInvitationV1: (id, params = {}) => this.request({
            path: `/api/v1/vendors/${id}/send-invitation`,
            method: "POST",
            secure: true,
            ...params,
        }),
        vendorControllerUpdateVendorV1: (id, data, params = {}) => this.request({
            path: `/api/v1/vendors/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        vendorControllerDeleteVendorV1: (id, params = {}) => this.request({
            path: `/api/v1/vendors/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        vendorQaControllerHardDeleteV1: (email, params = {}) => this.request({
            path: `/api/v1/vendors/emails/${email}`,
            method: "DELETE",
            ...params,
        }),
        vendorSettingControllerUpdateSettingsV1: (data, params = {}) => this.request({
            path: `/api/v1/vendor-settings`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        vendorAvatarControllerGetAvatarV1: (params = {}) => this.request({
            path: `/api/v1/vendors-settings/avatars`,
            method: "GET",
            secure: true,
            ...params,
        }),
        vendorAvatarControllerUploadAvatarV1: (data, params = {}) => this.request({
            path: `/api/v1/vendors-settings/avatars`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            ...params,
        }),
        vendorAvatarControllerDeleteAvatarV1: (params = {}) => this.request({
            path: `/api/v1/vendors-settings/avatars`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        dealControllerIndexV1: (query, params = {}) => this.request({
            path: `/api/v1/deals`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        dealControllerCreateV1: (data, params = {}) => this.request({
            path: `/api/v1/deals`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        dealControllerExportAdminsV1: (query, params = {}) => this.request({
            path: `/api/v1/deals/export`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
        dealControllerFindByIdV1: (id, params = {}) => this.request({
            path: `/api/v1/deals/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        dealControllerUpdateV1: (id, data, params = {}) => this.request({
            path: `/api/v1/deals/${id}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        dealControllerDownloadV1: (id, params = {}) => this.request({
            path: `/api/v1/deals/${id}/receipts/download`,
            method: "GET",
            secure: true,
            ...params,
        }),
        dealPaymentControllerCreateSessionV1: (id, params = {}) => this.request({
            path: `/api/v1/deals/${id}/payments/sessions`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
        dealStatisticControllerGetGeneralStatisticV1: (query, params = {}) => this.request({
            path: `/api/v1/deal-statistics/general`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        dealStatisticControllerGetFrameworkStatisticV1: (query, params = {}) => this.request({
            path: `/api/v1/deal-statistics/frameworks`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        dealStatisticControllerGetCountriesStatisticV1: (query, params = {}) => this.request({
            path: `/api/v1/deal-statistics/countries`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        dealStatisticControllerGetActivitiesStatisticV1: (query, params = {}) => this.request({
            path: `/api/v1/deal-statistics/activities`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        dealSettingControllerIndexV1: (params = {}) => this.request({
            path: `/api/v1/deals/settings`,
            method: "GET",
            secure: true,
            ...params,
        }),
        dealClientControllerCreateSessionV1: (id, params = {}) => this.request({
            path: `/api/v1/deals/${id}/clients/send-credentials`,
            method: "POST",
            secure: true,
            ...params,
        }),
        trustedSourceControllerIndexV1: (query, params = {}) => this.request({
            path: `/api/v1/trusted-sources`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        trustedSourceControllerCreateV1: (data, params = {}) => this.request({
            path: `/api/v1/trusted-sources`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        trustedSourceControllerExportV1: (query, params = {}) => this.request({
            path: `/api/v1/trusted-sources/export`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
        trustedSourceControllerFindOneV1: (id, params = {}) => this.request({
            path: `/api/v1/trusted-sources/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        trustedSourceControllerUpdateV1: (id, data, params = {}) => this.request({
            path: `/api/v1/trusted-sources/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        trustedSourceControllerDeleteV1: (id, params = {}) => this.request({
            path: `/api/v1/trusted-sources/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        trustedSourceControllerCreateManyV1: (data, params = {}) => this.request({
            path: `/api/v1/trusted-sources/many`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        accessTokenControllerIndexV1: (query, params = {}) => this.request({
            path: `/api/v1/projects/access-tokens`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        accessTokenControllerCreateV1: (data, params = {}) => this.request({
            path: `/api/v1/projects/access-tokens`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        accessTokenControllerDeleteV1: (id, params = {}) => this.request({
            path: `/api/v1/projects/access-tokens/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        sseControllerSseV1: (params = {}) => this.request({
            path: `/api/v1/server-sent-events`,
            method: "GET",
            secure: true,
            ...params,
        }),
        enterpriseControllerIndexV1: (query, params = {}) => this.request({
            path: `/api/v1/enterprises`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        enterpriseControllerCreateV1: (data, params = {}) => this.request({
            path: `/api/v1/enterprises`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        enterpriseControllerUpdateV1: (id, data, params = {}) => this.request({
            path: `/api/v1/enterprises/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        enterpriseControllerDeleteV1: (id, params = {}) => this.request({
            path: `/api/v1/enterprises/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        termsControllerIndexV1: (query, params = {}) => this.request({
            path: `/api/v1/terms`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        termsControllerCreateV1: (data, params = {}) => this.request({
            path: `/api/v1/terms`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        termsControllerShowV1: (id, params = {}) => this.request({
            path: `/api/v1/terms/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        termsControllerUpdateV1: (id, data, params = {}) => this.request({
            path: `/api/v1/terms/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        termsControllerDeleteV1: (id, params = {}) => this.request({
            path: `/api/v1/terms/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        publicTermsControllerLastV1: (query, params = {}) => this.request({
            path: `/api/v1/terms/last`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        userJourneyControllerGuestTrackV1: (data, params = {}) => this.request({
            path: `/api/v1/user-journey/guest/track`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            ...params,
        }),
        userJourneyControllerTrackV1: (data, params = {}) => this.request({
            path: `/api/v1/user-journey/track`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        whitepaperPublicControllerGetWhitepapersV1: (params = {}) => this.request({
            path: `/api/v1/public/whitepapers`,
            method: "GET",
            ...params,
        }),
        publicControllerGroupsV1: (params = {}) => this.request({
            path: `/api/v1/public/groups`,
            method: "GET",
            format: "json",
            ...params,
        }),
        publicControllerGroupV1: (group, params = {}) => this.request({
            path: `/api/v1/public/groups/${group}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        publicControllerPagesV1: (group, page, params = {}) => this.request({
            path: `/api/v1/public/groups/${group}/pages/${page}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        leadControllerIndexV1: (query, params = {}) => this.request({
            path: `/api/v1/leads`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        leadControllerStoreAdminV1: (data, params = {}) => this.request({
            path: `/api/v1/leads`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        leadControllerExportV1: (query, params = {}) => this.request({
            path: `/api/v1/leads/export`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
        leadControllerFindV1: (id, params = {}) => this.request({
            path: `/api/v1/leads/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        leadControllerUpdateAdminV1: (id, data, params = {}) => this.request({
            path: `/api/v1/leads/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        leadControllerDeleteAdminV1: (id, params = {}) => this.request({
            path: `/api/v1/leads/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        leadTechStackControllerGroupsV1: (params = {}) => this.request({
            path: `/api/v1/leads/tech-stack/groups`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        publicUsageHistoryControllerLimitsV1: (type, params = {}) => this.request({
            path: `/api/v1/public/free-tools/${type}/limits`,
            method: "GET",
            format: "json",
            ...params,
        }),
        publicA11YSgControllerStoreV1: (data, params = {}) => this.request({
            path: `/api/v1/public/free-tools/a11y-sg`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        publicA11YScannerControllerStoreV1: (data, params = {}) => this.request({
            path: `/api/v1/public/free-tools/a11y-scanner`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        adminUsageHistoryControllerIndexV1: (query, params = {}) => this.request({
            path: `/api/v1/admin/free-tools`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        adminA11YScannerControllerStoreV1: (data, params = {}) => this.request({
            path: `/api/v1/admin/free-tools/a11y-scanner`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        blogControllerWebhookV1: (params = {}) => this.request({
            path: `/api/v1/blog/webhook`,
            method: "POST",
            ...params,
        }),
        genaiImageControllerGenerateImageDescriptiosV1: (data, params = {}) => this.request({
            path: `/api/v1/genai/images/descriptions`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        publicCompetitorControllerGetListV1: (params = {}) => this.request({
            path: `/api/v1/public/competitors`,
            method: "GET",
            ...params,
        }),
        publicCompetitorControllerGetOneV1: (code, params = {}) => this.request({
            path: `/api/v1/public/competitors/${code}`,
            method: "GET",
            ...params,
        }),
        featureControllerFindAllActiveV1: (params = {}) => this.request({
            path: `/api/v1/features`,
            method: "GET",
            secure: true,
            ...params,
        }),
        userControllerIndexV1: (params = {}) => this.request({
            path: `/api/v1/users`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        userControllerStoreV1: (data, params = {}) => this.request({
            path: `/api/v1/users`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        userControllerUpdateV1: (id, data, params = {}) => this.request({
            path: `/api/v1/users/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        userControllerDeleteV1: (id, params = {}) => this.request({
            path: `/api/v1/users/${id}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        userDevControllerHardDeleteV1: (email, params = {}) => this.request({
            path: `/api/v1/users/emails/${email}`,
            method: "DELETE",
            ...params,
        }),
    };
    files = {
        fileControllerFile: (filename, params = {}) => this.request({
            path: `/files/${filename}`,
            method: "GET",
            ...params,
        }),
    };
}
exports.Api = Api;
//# sourceMappingURL=api.client.js.map